type Keys = keyof typeof rolesEnum;
type Values = (typeof rolesEnum)[Keys];

// Autogenerated file
export const rolesEnum = {
    Root: "Root",
    Admin: "Admin",
    Driver: "Driver",
    Guest: "Guest",
    TechSupport: "TechSupport",
    Diagnostics: "Diagnostics",
    TruckingOrganizationAdmin: "TruckingOrganizationAdmin",
    TruckingOrganizationManager: "TruckingOrganizationManager",
    TruckingOrganizationHeadLogist: "TruckingOrganizationHeadLogist",
    TruckingOrganizationOperator: "TruckingOrganizationOperator",
    TruckingOrganizationViewer: "TruckingOrganizationViewer",
    TruckingOrganizationDispatcher: "TruckingOrganizationDispatcher",
    TruckingOrganizationExtendedViewer: "TruckingOrganizationExtendedViewer",
    CargoOwnerAdmin: "CargoOwnerAdmin",
    CargoOwnerManager: "CargoOwnerManager",
    ForwarderAdmin: "ForwarderAdmin",
    ForwarderManager: "ForwarderManager",
    DataAdmin: "DataAdmin",
    IntegrationAccount: "IntegrationAccount",
    IntegrationManager: "IntegrationManager",
    AccountManager: "AccountManager",
    WaybillIntegrationAccount: "WaybillIntegrationAccount",
    ManagementSystem: "ManagementSystem",
} as const;

export const roles = [
    { label: "Суперадминистратор/разработчик", value: "Root" },
    { label: "Администратор", value: "Admin" },
    { label: "Водитель", value: "Driver" },
    { label: "Гость", value: "Guest" },
    { label: "Тех. поддержка", value: "TechSupport" },
    { label: "Наблюдатель сервера", value: "Diagnostics" },
    { label: "Администратор транспортной компании", value: "TruckingOrganizationAdmin" },
    { label: "Менеджер транспортной компании", value: "TruckingOrganizationManager" },
    { label: "Главный логист транспортной компании", value: "TruckingOrganizationHeadLogist" },
    { label: "Оператор транспортной компании", value: "TruckingOrganizationOperator" },
    { label: "Наблюдатель транспортной компании", value: "TruckingOrganizationViewer" },
    { label: "Диспетчер транспортной компании", value: "TruckingOrganizationDispatcher" },
    { label: "Наблюдатель с расширенными правами", value: "TruckingOrganizationExtendedViewer" },
    { label: "Грузовладелец (Администратор)", value: "CargoOwnerAdmin" },
    { label: "Грузовладелец (Менеджер)", value: "CargoOwnerManager" },
    { label: "Экспедитор (Администратор)", value: "ForwarderAdmin" },
    { label: "Экспедитор (Менеджер)", value: "ForwarderManager" },
    { label: "Администратор данных", value: "DataAdmin" },
    { label: "Учетная запись для систем интеграции", value: "IntegrationAccount" },
    { label: "Интеграция", value: "IntegrationManager" },
    { label: "Аккаунт менеджер", value: "AccountManager" },
    { label: "Интеграция ЭТрН", value: "WaybillIntegrationAccount" },
    { label: "Система управления", value: "ManagementSystem" },
] as unknown as Array<{ label: string; value: Values }>;
